import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	refreshCategory: false
}

const Category = createSlice({
	name: 'Category',
	initialState,
	reducers: {
		setRefreshCategory: (state, { payload }) => ({ refreshCategory: payload })
	}
})

export const { setRefreshCategory } = Category.actions
export default Category.reducer
